import { OrganizationUpdate } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<EntityType<OrganizationUpdate>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const updateAdminOrganizationDetailsReducer = createReducer<State, Actions>(initialState, {
  [actions.updateAdminOrganizationDetails.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.updateAdminOrganizationDetails.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.updateAdminOrganizationDetails.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.updateAdminOrganizationDetails.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default updateAdminOrganizationDetailsReducer;
